import type { Theme } from '@mui/material';

export const useStyles = (theme: Theme) => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  faButton: {
    position: 'fixed',
    bottom: 16,
    right: 16,
  },
  listTitle: {
    padding: theme.spacing(3),
  },
});
